import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { WidthContainer } from 'components/_new/layout/widthContainer'
import Text from 'components/_new/typography/Text/Text'

import Section from '../Section/Section'
import Note from '../Note/Note'

import messages from './messages'
import s from './WelcomeSection.scss'


const WelcomeSection = ({ className, email }) => (
  <Section className={cx(s.firstSlide, className)}>
    <WidthContainer className={s.content}>
      <Text className={s.title} message={messages.title} size="38-48" semibold uppercase />
      <Note big className={s.note} message={{ ...messages.emailSent, values: { email } }} />
      <Note message={messages.note} />
    </WidthContainer>
  </Section>
)

WelcomeSection.propTypes = {
  className: PropTypes.string,
  email: PropTypes.string,
}

export default WelcomeSection
